'use strict';

/**
 *
 * @name: NnTrackingPixel
 *
 */

function NnTrackingPixelDirective() {

  'ngInject';

  return {
    template: '<div class="nn-tracking-pixel" style="display: none;">' +
      '<div data-ng-if="code" data-ng-bind-html="code"></div>' +
    '</div>',
    restrict: 'E',
    replace: true,
    transclude: true,
    scope: {
      code: '=code'
    }
  };
}

export default NnTrackingPixelDirective;



// WEBPACK FOOTER //
// ./app/components/nn-generic-directives/nn-tracking-pixel.directive.js